import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

import AppNavbar from './components/AppNavbar/AppNavbar';
import Menu from './components/Menu/Menu';  
import Admin from './components/Admin/Admin';
import Login from './components/Login/Login';

class App extends Component {

  render() {
    return (
      <Router>
        <div className="App">
          <AppNavbar />
          <Route exact path="/" render={() => (<Redirect to="/menu"/>)} />
          <Route path="/menu" component={Menu} />
          <Route path="/admin" component={Admin} />
          <Route path="/login" component={Login} />
        </div>
      </Router>
    );
  }
}

export default App;
